<div class="flex items-center gap-x-2">

    <app-button
        [label]="'Layout'"
        [disabled]="venueLayout.isAnimating()"
        [active]="venueLayout.showContainer()"
        [custom]="['dark-button']"
        (event)="venueLayout.toggleContainer()"
    />

</div>
